import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DeviceFactory } from '../../../../device-factory/device-factory';

@Component({
	selector: 'app-daily-fleet-utilization',
	templateUrl: './daily-fleet-utilization.component.html',
	styleUrls: ['./daily-fleet-utilization.component.css']
})
export class DailyFleetUtilizationComponent {
	@Input() toDate = new Date();
	@Input() fromDate = new Date(this.toDate.getTime() - 30 * 24 * 60 * 60 * 1000); // 30 days ago
	@Input() selectedTruckType = "All";
	@Input() selectedTruckManufacturer = "All";
	@Output() prepareParentFiltersOptions = new EventEmitter<{ truckTypes: any[], truckManufacturers: any[] }>();

	chart = {
		firstChartTitle: this.translate.instant('utilization.daily_fleet_utilization'),
		secondChartTitle: this.translate.instant('utilization.daily_percent_fleet_utilization'),
	}
	devicesType = [DeviceFactory.types.iotah];

	constructor(
		private translate: TranslateService
	) {}

	onPrepareParentFiltersOptions(event: { truckTypes: any[], truckManufacturers: any[] }) {
		this.prepareParentFiltersOptions.emit({ truckTypes: event.truckTypes, truckManufacturers: event.truckManufacturers });
	}
}
